
import { Mail, Clock, MessageCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import useAnalytics from "@/hooks/use-analytics";

const ContactSection = () => {
  const { trackButtonClick } = useAnalytics();

  const handleContactClick = (contactType: string) => {
    trackButtonClick(`contact_${contactType}`, 'atendimento');
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <Card className="shadow-lg">
            <CardContent className="p-6">
              <Mail className="w-10 h-10 text-drcash-caribbean-green mb-4" />
              <h3 className="text-xl font-bold text-drcash-maastricht-blue mb-2">
                Email
              </h3>
              <p className="text-gray-600 mb-4">
                Entre em contato através do nosso email:
              </p>
              <a 
                href="mailto:contato@drcash.com.br"
                className="text-drcash-caribbean-green hover:underline"
                onClick={() => handleContactClick('email')}
              >
                contato@drcash.com.br
              </a>
            </CardContent>
          </Card>

          <Card className="shadow-lg">
            <CardContent className="p-6">
              <MessageCircle className="w-10 h-10 text-drcash-caribbean-green mb-4" />
              <h3 className="text-xl font-bold text-drcash-maastricht-blue mb-2">
                WhatsApp
              </h3>
              <p className="text-gray-600 mb-4">
                Fale conosco pelo WhatsApp:
              </p>
              <a 
                href="https://wa.me/5511933398890"
                target="_blank"
                rel="noopener noreferrer"
                className="text-drcash-caribbean-green hover:underline"
                onClick={() => handleContactClick('whatsapp')}
              >
                (11) 93339-8890
              </a>
            </CardContent>
          </Card>

          <Card className="shadow-lg">
            <CardContent className="p-6">
              <Clock className="w-10 h-10 text-drcash-caribbean-green mb-4" />
              <h3 className="text-xl font-bold text-drcash-maastricht-blue mb-2">
                Horário de Atendimento
              </h3>
              <p className="text-gray-600">
                Segunda a Sexta:
                <br />
                8h às 18h
                <br />
                Sábado e feriados:
                <br />
                9h às 17h
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
